export const EMAIL_REGEX = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);

export const IMAGE_REGEX = /\.(bmp|gif|jpg|jpeg|png|webp|jfif)$/i;
